/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AutopilotListRendererQueryVariables = {
    orgRelayId: string;
    timeZone: string;
    calendarId: string;
    userCalendarIds: Array<string>;
    calendarIds: Array<string | null>;
    externalEventIds: Array<string>;
};
export type AutopilotListRendererQueryResponse = {
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"AutopilotList_org" | "AutopilotList_orgRefetch">;
    } | null;
};
export type AutopilotListRendererQuery = {
    readonly response: AutopilotListRendererQueryResponse;
    readonly variables: AutopilotListRendererQueryVariables;
};



/*
query AutopilotListRendererQuery(
  $orgRelayId: ID!
  $timeZone: String!
  $calendarId: String!
  $userCalendarIds: [String!]!
  $calendarIds: [String]!
  $externalEventIds: [String!]!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...AutopilotList_org_IC4Kj
      ...AutopilotList_orgRefetch_2J4lOI
    }
    id
  }
}

fragment AutopilotList_orgRefetch_2J4lOI on Org {
  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        userId
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $userCalendarIds) {
    __typename
    ... on CanScheduleResponseList {
      list {
        externalEventId
        canAutopilot
      }
    }
  }
}

fragment AutopilotList_org_IC4Kj on Org {
  ...EventSummaryAutopilot_org
  ...EventSummaryTime_org
  ...EventSummaryRecurrence_org
  id
  experiments
  focusTimeSavedInHours
  primaryOrgEmail
  primaryOrgCalendar
  autopilotEventsResponse(timeZone: $timeZone) {
    __typename
    ... on AutopilotEventsResponse {
      enabledOrganized {
        ...EventSummaryTime_event
        ...EventSummaryRecurrence_event
        ...EventSummaryAutopilot_event_3GsBW
        suggestedAutopilotSettingsResponseV3 {
          __typename
          ... on SuggestedAutopilotSettingsResponseV3 {
            intersectionOfAttendeesMeetingHours {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
            calendarIdToMeetingHours {
              calendarId
              dayOffsetTimeSlotRanges {
                minSlot {
                  dayOffset
                  timeSlot
                }
                maxSlot {
                  dayOffset
                  timeSlot
                }
              }
            }
            suggestedAutopilotSettings {
              isRoomFlexible
              movementType
              allowedEndTime {
                dayOffset
                timeSlot
              }
              allowedStartTime {
                dayOffset
                timeSlot
              }
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        moveRangeInLocalTimeV3 {
          __typename
          ... on MoveRangeInLocalTimeV3 {
            allowedStartTimeInclusive {
              dayOffset
              timeSlot
            }
            allowedEndTimeInclusive {
              dayOffset
              timeSlot
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        recurrenceRules {
          timeZone
        }
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              value
              subjectType
            }
          }
          id
        }
        title
        createdMillis
        isClockwiseEvent
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
      }
      enabledAttending {
        ...EventSummaryTime_event
        ...EventSummaryRecurrence_event
        ...EventSummaryAutopilot_event_3GsBW
        recurrenceRules {
          timeZone
        }
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              value
              subjectType
            }
          }
          id
        }
        title
        createdMillis
        isClockwiseEvent
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
          displayName
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
      }
      suggestedOrganized {
        ...EventSummaryTime_event
        ...EventSummaryRecurrence_event
        ...EventSummaryAutopilot_event_3GsBW
        suggestedAutopilotSettingsResponseV3 {
          __typename
          ... on SuggestedAutopilotSettingsResponseV3 {
            intersectionOfAttendeesMeetingHours {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
            calendarIdToMeetingHours {
              calendarId
              dayOffsetTimeSlotRanges {
                minSlot {
                  dayOffset
                  timeSlot
                }
                maxSlot {
                  dayOffset
                  timeSlot
                }
              }
            }
            suggestedAutopilotSettings {
              isRoomFlexible
              movementType
              allowedEndTime {
                dayOffset
                timeSlot
              }
              allowedStartTime {
                dayOffset
                timeSlot
              }
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        moveRangeInLocalTimeV3 {
          __typename
          ... on MoveRangeInLocalTimeV3 {
            allowedStartTimeInclusive {
              dayOffset
              timeSlot
            }
            allowedEndTimeInclusive {
              dayOffset
              timeSlot
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        recurrenceRules {
          timeZone
        }
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              value
              subjectType
            }
          }
          id
        }
        title
        createdMillis
        isClockwiseEvent
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
      }
      suggestedAttending {
        ...EventSummaryTime_event
        ...EventSummaryRecurrence_event
        ...EventSummaryAutopilot_event_3GsBW
        recurrenceRules {
          timeZone
        }
        suggestedAutopilotSettingsResponseV3 {
          __typename
          ... on SuggestedAutopilotSettingsResponseV3 {
            intersectionOfAttendeesMeetingHours {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
            calendarIdToMeetingHours {
              calendarId
              dayOffsetTimeSlotRanges {
                minSlot {
                  dayOffset
                  timeSlot
                }
                maxSlot {
                  dayOffset
                  timeSlot
                }
              }
            }
            suggestedAutopilotSettings {
              isRoomFlexible
              movementType
              allowedEndTime {
                dayOffset
                timeSlot
              }
              allowedStartTime {
                dayOffset
                timeSlot
              }
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              value
              subjectType
            }
          }
          id
        }
        title
        createdMillis
        isClockwiseEvent
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment EventSummaryAutopilot_event_3GsBW on Event {
  autopilotEventStatus(calendarId: $calendarId) {
    __typename
    ... on AutopilotEventStatus {
      status
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
  featureStatesForOrganizer {
    __typename
    ... on FeatureStates {
      mixedFreemiumOrgUIState {
        autopilotPaused
        moveRangesEnabled
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment EventSummaryAutopilot_org on Org {
  id
  experiments
}

fragment EventSummaryRecurrence_event on Event {
  isAllDay
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryRecurrence_org on Org {
  id
  primaryOrgCalendar
}

fragment EventSummaryTime_event on Event {
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryTime_org on Org {
  id
  primaryOrgCalendar
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarIds"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "externalEventIds"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeZone"
    } as any, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userCalendarIds"
    } as any, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v7 = {
        "kind": "Variable",
        "name": "calendarId",
        "variableName": "calendarId"
    } as any, v8 = {
        "kind": "Variable",
        "name": "timeZone",
        "variableName": "timeZone"
    } as any, v9 = {
        "kind": "Variable",
        "name": "calendarIds",
        "variableName": "calendarIds"
    } as any, v10 = {
        "kind": "Variable",
        "name": "externalEventIds",
        "variableName": "externalEventIds"
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v14 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        (v13 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any
    ], v15 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "startTime",
        "plural": false,
        "selections": (v14 /*: any*/),
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "endTime",
        "plural": false,
        "selections": (v14 /*: any*/),
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "concreteType": "EventKey",
        "kind": "LinkedField",
        "name": "eventKey",
        "plural": false,
        "selections": [
            (v17 /*: any*/),
            (v12 /*: any*/)
        ],
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "eventFlexibilityErrorable",
        "plural": false,
        "selections": [
            (v11 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventFlexibilityNew",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flex",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flexString",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "EventFlexibilityNewList",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "concreteType": "RecurrenceRules",
        "kind": "LinkedField",
        "name": "recurrenceRules",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "firstInstanceStartTime",
                "plural": false,
                "selections": (v14 /*: any*/),
                "storageKey": null
            },
            (v13 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "IntervalDefinition",
                "kind": "LinkedField",
                "name": "interval",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "interval",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "byDay",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bySetPos",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "freqType",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "untilTime",
                        "plural": false,
                        "selections": (v14 /*: any*/),
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v21 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgTag",
            "kind": "LinkedField",
            "name": "orgTags",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tag",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TagState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subjectType",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any,
        (v12 /*: any*/)
    ], v22 = {
        "alias": null,
        "args": null,
        "concreteType": "AnnotatedEvent",
        "kind": "LinkedField",
        "name": "annotatedEvent",
        "plural": false,
        "selections": (v21 /*: any*/),
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAllDay",
        "storageKey": null
    } as any, v24 = {
        "alias": null,
        "args": [
            (v7 /*: any*/)
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "autopilotEventStatus",
        "plural": false,
        "selections": [
            (v11 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                    }
                ],
                "type": "AutopilotEventStatus",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "concreteType": "AnnotatedEvent",
        "kind": "LinkedField",
        "name": "annotatedRecurringEvent",
        "plural": false,
        "selections": (v21 /*: any*/),
        "storageKey": null
    } as any, v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v27 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "featureStatesForOrganizer",
        "plural": false,
        "selections": [
            (v11 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "MixedFreemiumOrgUiState",
                        "kind": "LinkedField",
                        "name": "mixedFreemiumOrgUIState",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "autopilotPaused",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "moveRangesEnabled",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "FeatureStates",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                    },
                    (v26 /*: any*/)
                ],
                "type": "GraphEntityError",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any, v28 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOffset",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSlot",
            "storageKey": null
        } as any
    ], v29 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "minSlot",
            "plural": false,
            "selections": (v28 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "maxSlot",
            "plural": false,
            "selections": (v28 /*: any*/),
            "storageKey": null
        } as any
    ], v30 = {
        "kind": "InlineFragment",
        "selections": [
            (v26 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v31 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "suggestedAutopilotSettingsResponseV3",
        "plural": false,
        "selections": [
            (v11 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "DayOffsetTimeSlotRange",
                        "kind": "LinkedField",
                        "name": "intersectionOfAttendeesMeetingHours",
                        "plural": false,
                        "selections": (v29 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours",
                        "kind": "LinkedField",
                        "name": "calendarIdToMeetingHours",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "calendarId",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlotRange",
                                "kind": "LinkedField",
                                "name": "dayOffsetTimeSlotRanges",
                                "plural": true,
                                "selections": (v29 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SuggestedAutopilotSettingsV3",
                        "kind": "LinkedField",
                        "name": "suggestedAutopilotSettings",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isRoomFlexible",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "movementType",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlot",
                                "kind": "LinkedField",
                                "name": "allowedEndTime",
                                "plural": false,
                                "selections": (v28 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlot",
                                "kind": "LinkedField",
                                "name": "allowedStartTime",
                                "plural": false,
                                "selections": (v28 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "SuggestedAutopilotSettingsResponseV3",
                "abstractKey": null
            },
            (v30 /*: any*/)
        ],
        "storageKey": null
    } as any, v32 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v33 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdMillis",
        "storageKey": null
    } as any, v34 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isClockwiseEvent",
        "storageKey": null
    } as any, v35 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v36 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "organizer",
        "plural": false,
        "selections": [
            (v35 /*: any*/)
        ],
        "storageKey": null
    } as any, v37 = [
        (v15 /*: any*/),
        (v16 /*: any*/),
        (v18 /*: any*/),
        (v19 /*: any*/),
        (v20 /*: any*/),
        (v22 /*: any*/),
        (v23 /*: any*/),
        (v24 /*: any*/),
        (v25 /*: any*/),
        (v27 /*: any*/),
        (v31 /*: any*/),
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "moveRangeInLocalTimeV3",
            "plural": false,
            "selections": [
                (v11 /*: any*/),
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DayOffsetTimeSlot",
                            "kind": "LinkedField",
                            "name": "allowedStartTimeInclusive",
                            "plural": false,
                            "selections": (v28 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DayOffsetTimeSlot",
                            "kind": "LinkedField",
                            "name": "allowedEndTimeInclusive",
                            "plural": false,
                            "selections": (v28 /*: any*/),
                            "storageKey": null
                        }
                    ],
                    "type": "MoveRangeInLocalTimeV3",
                    "abstractKey": null
                },
                (v30 /*: any*/)
            ],
            "storageKey": null
        } as any,
        (v32 /*: any*/),
        (v33 /*: any*/),
        (v34 /*: any*/),
        (v36 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AutopilotListRendererQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v6 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": [
                                        (v7 /*: any*/),
                                        (v8 /*: any*/)
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "AutopilotList_org"
                                },
                                {
                                    "args": [
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        {
                                            "kind": "Variable",
                                            "name": "userCalendarIds",
                                            "variableName": "userCalendarIds"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "AutopilotList_orgRefetch"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v0 /*: any*/),
                (v5 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AutopilotListRendererQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v6 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v11 /*: any*/),
                        (v12 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgCalendar",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "focusTimeSavedInHours",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgEmail",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v8 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "autopilotEventsResponse",
                                    "plural": false,
                                    "selections": [
                                        (v11 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "enabledOrganized",
                                                    "plural": true,
                                                    "selections": (v37 /*: any*/),
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "enabledAttending",
                                                    "plural": true,
                                                    "selections": [
                                                        (v15 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v23 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v25 /*: any*/),
                                                        (v27 /*: any*/),
                                                        (v32 /*: any*/),
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Attendee",
                                                            "kind": "LinkedField",
                                                            "name": "organizer",
                                                            "plural": false,
                                                            "selections": [
                                                                (v35 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "suggestedOrganized",
                                                    "plural": true,
                                                    "selections": (v37 /*: any*/),
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "suggestedAttending",
                                                    "plural": true,
                                                    "selections": [
                                                        (v15 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v23 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v25 /*: any*/),
                                                        (v27 /*: any*/),
                                                        (v31 /*: any*/),
                                                        (v32 /*: any*/),
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/),
                                                        (v36 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "AutopilotEventsResponse",
                                            "abstractKey": null
                                        },
                                        (v30 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v9 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personsByCalendarIdsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v11 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Person",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v12 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "emails",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "UserProfile",
                                                            "kind": "LinkedField",
                                                            "name": "profile",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "givenName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "familyName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "externalImageUrl",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isYou",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "userId",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "PersonList",
                                            "abstractKey": null
                                        },
                                        (v30 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "calendarIds",
                                            "variableName": "userCalendarIds"
                                        },
                                        (v10 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "canScheduleResponse",
                                    "plural": false,
                                    "selections": [
                                        (v11 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CanScheduleResponse",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v17 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "canAutopilot",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "CanScheduleResponseList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "51f287f7677349b2c2114130c75b0a71",
            "id": null,
            "metadata": {},
            "name": "AutopilotListRendererQuery",
            "operationKind": "query",
            "text": "query AutopilotListRendererQuery(\n  $orgRelayId: ID!\n  $timeZone: String!\n  $calendarId: String!\n  $userCalendarIds: [String!]!\n  $calendarIds: [String]!\n  $externalEventIds: [String!]!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...AutopilotList_org_IC4Kj\n      ...AutopilotList_orgRefetch_2J4lOI\n    }\n    id\n  }\n}\n\nfragment AutopilotList_orgRefetch_2J4lOI on Org {\n  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        userId\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $userCalendarIds) {\n    __typename\n    ... on CanScheduleResponseList {\n      list {\n        externalEventId\n        canAutopilot\n      }\n    }\n  }\n}\n\nfragment AutopilotList_org_IC4Kj on Org {\n  ...EventSummaryAutopilot_org\n  ...EventSummaryTime_org\n  ...EventSummaryRecurrence_org\n  id\n  experiments\n  focusTimeSavedInHours\n  primaryOrgEmail\n  primaryOrgCalendar\n  autopilotEventsResponse(timeZone: $timeZone) {\n    __typename\n    ... on AutopilotEventsResponse {\n      enabledOrganized {\n        ...EventSummaryTime_event\n        ...EventSummaryRecurrence_event\n        ...EventSummaryAutopilot_event_3GsBW\n        suggestedAutopilotSettingsResponseV3 {\n          __typename\n          ... on SuggestedAutopilotSettingsResponseV3 {\n            intersectionOfAttendeesMeetingHours {\n              minSlot {\n                dayOffset\n                timeSlot\n              }\n              maxSlot {\n                dayOffset\n                timeSlot\n              }\n            }\n            calendarIdToMeetingHours {\n              calendarId\n              dayOffsetTimeSlotRanges {\n                minSlot {\n                  dayOffset\n                  timeSlot\n                }\n                maxSlot {\n                  dayOffset\n                  timeSlot\n                }\n              }\n            }\n            suggestedAutopilotSettings {\n              isRoomFlexible\n              movementType\n              allowedEndTime {\n                dayOffset\n                timeSlot\n              }\n              allowedStartTime {\n                dayOffset\n                timeSlot\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n        moveRangeInLocalTimeV3 {\n          __typename\n          ... on MoveRangeInLocalTimeV3 {\n            allowedStartTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n            allowedEndTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n        recurrenceRules {\n          timeZone\n        }\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              value\n              subjectType\n            }\n          }\n          id\n        }\n        title\n        createdMillis\n        isClockwiseEvent\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n      }\n      enabledAttending {\n        ...EventSummaryTime_event\n        ...EventSummaryRecurrence_event\n        ...EventSummaryAutopilot_event_3GsBW\n        recurrenceRules {\n          timeZone\n        }\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              value\n              subjectType\n            }\n          }\n          id\n        }\n        title\n        createdMillis\n        isClockwiseEvent\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n          displayName\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n      }\n      suggestedOrganized {\n        ...EventSummaryTime_event\n        ...EventSummaryRecurrence_event\n        ...EventSummaryAutopilot_event_3GsBW\n        suggestedAutopilotSettingsResponseV3 {\n          __typename\n          ... on SuggestedAutopilotSettingsResponseV3 {\n            intersectionOfAttendeesMeetingHours {\n              minSlot {\n                dayOffset\n                timeSlot\n              }\n              maxSlot {\n                dayOffset\n                timeSlot\n              }\n            }\n            calendarIdToMeetingHours {\n              calendarId\n              dayOffsetTimeSlotRanges {\n                minSlot {\n                  dayOffset\n                  timeSlot\n                }\n                maxSlot {\n                  dayOffset\n                  timeSlot\n                }\n              }\n            }\n            suggestedAutopilotSettings {\n              isRoomFlexible\n              movementType\n              allowedEndTime {\n                dayOffset\n                timeSlot\n              }\n              allowedStartTime {\n                dayOffset\n                timeSlot\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n        moveRangeInLocalTimeV3 {\n          __typename\n          ... on MoveRangeInLocalTimeV3 {\n            allowedStartTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n            allowedEndTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n        recurrenceRules {\n          timeZone\n        }\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              value\n              subjectType\n            }\n          }\n          id\n        }\n        title\n        createdMillis\n        isClockwiseEvent\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n      }\n      suggestedAttending {\n        ...EventSummaryTime_event\n        ...EventSummaryRecurrence_event\n        ...EventSummaryAutopilot_event_3GsBW\n        recurrenceRules {\n          timeZone\n        }\n        suggestedAutopilotSettingsResponseV3 {\n          __typename\n          ... on SuggestedAutopilotSettingsResponseV3 {\n            intersectionOfAttendeesMeetingHours {\n              minSlot {\n                dayOffset\n                timeSlot\n              }\n              maxSlot {\n                dayOffset\n                timeSlot\n              }\n            }\n            calendarIdToMeetingHours {\n              calendarId\n              dayOffsetTimeSlotRanges {\n                minSlot {\n                  dayOffset\n                  timeSlot\n                }\n                maxSlot {\n                  dayOffset\n                  timeSlot\n                }\n              }\n            }\n            suggestedAutopilotSettings {\n              isRoomFlexible\n              movementType\n              allowedEndTime {\n                dayOffset\n                timeSlot\n              }\n              allowedStartTime {\n                dayOffset\n                timeSlot\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              value\n              subjectType\n            }\n          }\n          id\n        }\n        title\n        createdMillis\n        isClockwiseEvent\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment EventSummaryAutopilot_event_3GsBW on Event {\n  autopilotEventStatus(calendarId: $calendarId) {\n    __typename\n    ... on AutopilotEventStatus {\n      status\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n  featureStatesForOrganizer {\n    __typename\n    ... on FeatureStates {\n      mixedFreemiumOrgUIState {\n        autopilotPaused\n        moveRangesEnabled\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment EventSummaryAutopilot_org on Org {\n  id\n  experiments\n}\n\nfragment EventSummaryRecurrence_event on Event {\n  isAllDay\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryRecurrence_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment EventSummaryTime_event on Event {\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryTime_org on Org {\n  id\n  primaryOrgCalendar\n}\n"
        }
    } as any;
})();
(node as any).hash = '41a6361871366ea9bdb522622e0b6f6b';
export default node;
